<template>
	<div>
		<!-- Modal -->
		<div
			class="modal fade"
			id="mdOptions"
			tabindex="-1"
			data-backdrop="static"
		>
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title" id="myModalLabel">
							Editar opções
						</h4>
					</div>
					<div class="modal-body">
						<div class="radio">
							<label>
								<input
									v-model="data.type"
									value="table-db"
									type="radio"
								/>
								Query SQL com aliases ( text, value [,printText]
								)
							</label>
						</div>

						<textarea
							class="form-control"
							v-model="data.inTable"
							rows="5"
							:disabled="data.type == 'options'"
						></textarea>
						<!-- <select class="form-control" v-model="data.inTable" :disabled=" data.type == 'options' ">
		      		<option value="">Escolher</option>
		      		<option value="clientes">Clientes</option>
		      		<option value="departamentos">Departamentos</option>
		      		<option value="estado">Estados</option>
		      		<option value="gestores">Gestores</option>
		      		<option value="regioes">Regiões</option>
		      		<option value="templates">Documentos</option>
		      		<option value="vendedores">Vendedores</option>
		      	</select> -->

						<div class="radio">
							<label>
								<input
									v-model="data.type"
									value="options"
									type="radio"
								/>
								Cadastar opções
							</label>
						</div>

						<div class="row">
							<div class="col-sm-12 text-right">
								<button
									v-if="data.type != 'table-db'"
									class="btn btn-success btn-xs"
									@click="addOpt"
								>
									<i class="fa fa-plus"></i>
									Nova opção
								</button>
							</div>
						</div>
						<div class="clearfix"></div>
						<br />

						<div>
							<div
								v-for="(opt, id) in data.options"
								class="col-sm-12 well well-sm"
							>
								<div class="row">
									<div class="col-sm-2">
										<input
											type="text"
											placeholder="Id"
											v-model="opt.value"
											class="form-control"
										/>
									</div>
									<div class="col-sm-8">
										<input
											type="text"
											placeholder="Titulo"
											v-model="opt.text"
											class="form-control"
										/>
									</div>
									<div class="col-sm-2">
										<button
											class="btn btn-danger btn-block"
											@click="removeOpt(id)"
										>
											<i class="fa fa-trash"></i>
										</button>
									</div>
									<div class="clearfix"></div>
									<br />
									<div class="col-sm-12">
										<textarea
											placeholder="Valor Impressão"
											v-model="opt.printText"
											class="form-control"
										>
										</textarea>
									</div>
								</div>
							</div>
						</div>

						<div class="clearfix"></div>
					</div>
					<div class="modal-footer">
						<button
							type="button"
							class="btn btn-default"
							data-dismiss="modal"
						>
							<i class="fa fa-close"></i>
						</button>
						<button
							type="button"
							class="btn btn-success"
							@click="comfirm"
						>
							<i class="fa fa-check"></i>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'MdOptions',
		props: ['options', 'typesl'],
		data() {
			return {
				option: {
					value: '',
					text: '',
				},
			};
		},
		computed: {
			data() {
				return this.options;
			},
		},

		// watch : {
		// 	data : function (data){
		// 		// if(data.type == "table-db"){

		// 		// }
		// 		// console.log(data)
		// 	}
		// },

		methods: {
			addOpt() {
				if (typeof this.data.options == 'object')
					this.data.options.push(this.option);
				else {
					this.data.options = [];
					this.data.options.push(this.option);
				}
				this.option = { value: '', text: '', printText: '' };
				jQuery('#value').focus();
			},
			removeOpt(id) {
				this.data.options.splice(id, 1);
			},
			comfirm() {
				this.$emit('confirm', this.data);
			},
		},
	};
</script>
<style scoped>
	.form-control-in-table {
		background: none;
		border: none;
		padding: 5px;
	}
	.radio {
		margin-bottom: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/models/create-form/components/mdOptions.vue